var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSolarmask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 156,
    viewBox: "0 0 244 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.5 141.5L44.5 38L46.5 25L57 17.5L119.5 23.5V141.5Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9171 31.2526C70.9171 39.0493 64.5746 45.3928 56.7769 45.3928C48.9812 45.3928 42.6388 39.0493 42.6388 31.2526C42.6388 23.4559 48.9812 17.1125 56.7769 17.1125C64.5746 17.1125 70.9171 23.4559 70.9171 31.2526ZM56.7769 21.2518C51.2631 21.2518 46.7781 25.7379 46.7781 31.2526C46.7781 36.7674 51.2631 41.2534 56.7769 41.2534C62.2907 41.2534 66.7777 36.7674 66.7777 31.2526C66.7777 25.7379 62.2907 21.2518 56.7769 21.2518Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7072 9.93511V2.06969C54.7072 0.926711 55.6329 0 56.7769 0C57.9209 0 58.8466 0.926711 58.8466 2.06969V9.93511C58.8466 11.0781 57.9209 12.0048 56.7769 12.0048C55.6329 12.0048 54.7072 11.0781 54.7072 9.93511Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9497 9.15374C76.7582 8.34527 78.0679 8.34527 78.8764 9.15374C79.6848 9.96221 79.6848 11.2719 78.8764 12.0804L73.3141 17.6427C72.9098 18.0469 72.3803 18.2491 71.8507 18.2491C71.3212 18.2491 70.7916 18.0469 70.3874 17.6427C69.5789 16.8342 69.5789 15.5245 70.3874 14.716L75.9497 9.15374Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0304 31.2527C88.0304 32.3956 87.1047 33.3223 85.9607 33.3223H78.0943C76.9503 33.3223 76.0246 32.3956 76.0246 31.2527C76.0246 30.1097 76.9503 29.183 78.0943 29.183H85.9607C87.1047 29.183 88.0304 30.1097 88.0304 31.2527Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3141 44.8632L78.8764 50.4245C79.6848 51.232 79.6848 52.5427 78.8764 53.3512C78.4721 53.7554 77.9426 53.9575 77.413 53.9575C76.8835 53.9575 76.3539 53.7554 75.9497 53.3512L70.3874 47.7899C69.5789 46.9824 69.5789 45.6717 70.3874 44.8632C71.1959 44.0547 72.5056 44.0547 73.3141 44.8632Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8466 52.57V60.4354C58.8466 61.5784 57.9209 62.5051 56.7769 62.5051C55.6329 62.5051 54.7072 61.5784 54.7072 60.4354V52.57C54.7072 51.427 55.6329 50.5003 56.7769 50.5003C57.9209 50.5003 58.8466 51.427 58.8466 52.57Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1683 44.8632C43.9767 45.6717 43.9767 46.9824 43.1683 47.7899L37.606 53.3512C37.2017 53.7554 36.6722 53.9575 36.1426 53.9575C35.6131 53.9575 35.0835 53.7554 34.6793 53.3512C33.8708 52.5427 33.8708 51.232 34.6793 50.4245L40.2416 44.8632C41.0501 44.0547 42.3598 44.0547 43.1683 44.8632Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5254 31.2527C25.5254 30.1097 26.4511 29.183 27.5951 29.183H35.4615C36.6055 29.183 37.5312 30.1097 37.5312 31.2527C37.5312 32.3956 36.6055 33.3223 35.4615 33.3223H27.5951C26.4511 33.3223 25.5254 32.3956 25.5254 31.2527Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.606 9.15374L43.1683 14.716C43.9767 15.5245 43.9767 16.8342 43.1683 17.6427C42.764 18.0469 42.2345 18.2491 41.7049 18.2491C41.1754 18.2491 40.6458 18.0469 40.2416 17.6427L34.6793 12.0804C33.8708 11.2719 33.8708 9.96221 34.6793 9.15374C35.4878 8.34527 36.7975 8.34527 37.606 9.15374Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6267 63.3755C94.5024 60.7122 93.1798 57.3922 93.1798 53.7234C93.1798 45.1401 100.137 38.1875 108.725 38.1875C109.463 38.1875 110.17 38.3007 110.89 38.4049C110.777 37.7028 110.663 36.9872 110.663 36.2444C110.663 28.7391 116.755 22.6471 124.265 22.6471C131.775 22.6471 137.863 28.7391 137.863 36.2444C137.863 36.9872 137.749 37.7028 137.641 38.4049C138.352 38.3052 139.063 38.1875 139.801 38.1875C148.384 38.1875 155.346 45.1401 155.346 53.7234C155.346 57.3922 154.028 60.7122 151.899 63.3755C153.53 64.1365 154.979 65.1873 156.32 66.3559L123.921 95.1493L128.795 100.639V141.775H142.383V103.547L174.089 75.3649L205.795 103.547V141.775H219.383V146.305H22.3534V141.775H119.736V91.9516C116.198 96.712 111.225 100.349 104.839 100.349C94.1083 100.349 85.4164 91.6527 85.4164 80.9225C85.4164 73.1364 90.0229 66.4736 96.6267 63.3755ZM165.03 141.775H183.148V114.599H165.03V141.775Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.336 102.301L130.312 95.5253L174.088 56.6177L217.865 95.5253L211.841 102.301L174.088 68.7384L136.336 102.301Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64258 143.27C8.64258 142.716 8.44727 142.293 8.05664 142C7.66602 141.701 6.96289 141.388 5.94727 141.062C4.93164 140.73 4.1276 140.405 3.53516 140.086C1.92057 139.214 1.11328 138.038 1.11328 136.561C1.11328 135.792 1.32812 135.109 1.75781 134.51C2.19401 133.904 2.81576 133.432 3.62305 133.094C4.43685 132.755 5.34831 132.586 6.35742 132.586C7.37305 132.586 8.27799 132.771 9.07227 133.143C9.86654 133.507 10.4818 134.025 10.918 134.695C11.3607 135.366 11.582 136.128 11.582 136.98H8.65234C8.65234 136.329 8.44727 135.825 8.03711 135.467C7.62695 135.102 7.05078 134.92 6.30859 134.92C5.59245 134.92 5.03581 135.073 4.63867 135.379C4.24154 135.678 4.04297 136.076 4.04297 136.57C4.04297 137.033 4.27409 137.42 4.73633 137.732C5.20508 138.045 5.89193 138.338 6.79688 138.611C8.46354 139.113 9.67773 139.734 10.4395 140.477C11.2012 141.219 11.582 142.143 11.582 143.25C11.582 144.48 11.1165 145.447 10.1855 146.15C9.25456 146.847 8.0013 147.195 6.42578 147.195C5.33203 147.195 4.33594 146.997 3.4375 146.6C2.53906 146.196 1.85221 145.646 1.37695 144.949C0.908203 144.253 0.673828 143.445 0.673828 142.527H3.61328C3.61328 144.096 4.55078 144.881 6.42578 144.881C7.1224 144.881 7.66602 144.741 8.05664 144.461C8.44727 144.174 8.64258 143.777 8.64258 143.27Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M238.832 147H235.902L230.199 137.645V147H227.27V132.781H230.199L235.912 142.156V132.781H238.832V147Z",
    fill: "url(#paint13_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 119.5,
    y1: 141.5,
    x2: 119.5,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 88.0304,
    y1: 62.5051,
    x2: 88.0304,
    y2: 0.00000245889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 219.383,
    y1: 22.6471,
    x2: 108.028,
    y2: 200.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 217.865,
    y1: 56.6177,
    x2: 180.394,
    y2: 128.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 0,
    y1: 129,
    x2: 24.9231,
    y2: 145.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 226,
    y1: 129,
    x2: 250.923,
    y2: 145.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolarmask);
export default __webpack_public_path__ + "static/media/icon-solarmask.97cd3bbbfd66d0885874c24701a84be1.svg";
export { ForwardRef as ReactComponent };